<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>حركة الخزن</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع حركة الخزن
              <div v-show="$per.value.saveTreasuryMovment" class='pull-left' style='padding=0px'>
                <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
              <ul v-if='mainValidationErrors'>
                  <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <!-- /.panel-heading -->
            <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px">
              <div class="panel panel-info">
                <div class="panel-heading" style="text-align: center;">
                  من
                </div>
                <div class="panel-body" style="padding: 5px">
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                    <label>الفرع</label>
                    <select @change="getTreasuryFrom()" class="form-control" style="padding:0px"  v-model="FilterFromBranchID">
                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                    <label>الخزنة</label>
                    <select class="form-control" style="padding:0px" v-model="FilterFromTreasuryID">
                      <option v-for="item in FilterFromTreasuries" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px">
              <div class="panel panel-info">
                <div class="panel-heading" style="text-align: center;">
                  الى
                </div>
                <div class="panel-body" style="padding: 5px">
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                    <label>الفرع</label>
                    <select @change="getTreasuryTo()" class="form-control" style="padding:0px" v-model="FilterToBranchID">
                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                    <label>الخزنة</label>
                    <select class="form-control" style="padding:0px" v-model="FilterToTreasuryID">
                      <option v-for="item in FilterToTreasuries" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px">
              <div class="panel panel-info">
                <div class="panel-heading" style="text-align: center;">
                  التاريخ
                </div>
                <div class="panel-body" style="padding: 5px">
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                    <tbDate :today='today'  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                  </div>
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                    <tbDate :today='today' :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px">
                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  <b> عرض </b>
                </button>
            </div>
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>من</th>
                    <th style='text-align: center'>الى</th>
                    <th style='text-align: center'>المبلغ</th>
                    <th style='text-align: center'>التاريخ</th>
                    <th style='text-align: center'>المستخدم</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                    <td align='center'>{{record.treasury_from_name}}</td>
                    <td align='center'>{{record.treasury_to_name}}</td>
                    <td align='center'>{{record.amount}}</td>
                    <td align='center'>{{record.date}}</td>
                    <td align='center'>{{record.user_name}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button v-show="$per.value.deleteTreasuryMovment" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button v-show="$per.value.editTreasuryMovment" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 5px">
                  <div class="panel panel-info">
                    <div class="panel-heading" style="text-align: center;">
                      من
                    </div>
                    <div class="panel-body" style="padding: 5px">
                      <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                        <label>الفرع</label>
                        <select @change="getTreasuryFrom()" class="form-control" style="padding:0px"  v-model="FilterFromBranchID">
                          <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                      <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                        <label>الخزنة</label>
                        <select class="form-control" style="padding:0px" v-model="record.treasury_from_id">
                          <option v-for="item in FilterFromTreasuries" v-bind:key="item.id" v-bind:value="item.id">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 5px">
                  <div class="panel panel-info">
                    <div class="panel-heading" style="text-align: center;">
                      الى
                    </div>
                    <div class="panel-body" style="padding: 5px">
                      <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                        <label>الفرع</label>
                        <select @change="getTreasuryTo()" class="form-control" style="padding:0px" v-model="FilterToBranchID">
                          <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                      <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 3px">
                        <label>الخزنة</label>
                        <select class="form-control" style="padding:0px" v-model="record.treasury_to_id">
                          <option v-for="item in FilterToTreasuries" v-bind:key="item.id" v-bind:value="item.id">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='form-group col-lg-4 col-sm-4' style="padding:2px">
                  <label>المبلغ:</label>
                  <input v-model='record.amount' class='form-control' name='amount' type='text'>
                </div>
                <div class='form-group col-lg-8 col-sm-8' style="padding:2px">
                  <tbDate :today='today' :mytitle='dateTitle' v-model= 'record.date' ></tbDate>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'treasury_movments',
  data () {
    return {
      today: true,
      FilterFromTreasuries: '',
      FilterToTreasuries: '',
      FilterFromTreasuryID: '',
      FilterToTreasuryID: '',
      FilterFromBranchID: '',
      FilterToBranchID: '',
      branches: '',
      fromTitle: 'من',
      toTitle: 'إلى',
      dateTitle: 'التاريخ',
      date_from: '',
      date_to: '',
      validationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      mainValidationErrors: '',
      emptyRec: [{id: 0, name: ''}],
      title: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
  },
  methods: {
    getTreasuryFrom () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranchTreasuries', {
        token: localStorage.getItem('token'),
        branche_id: this.FilterFromBranchID
      })
        .then(({ data }) => {
          this.FilterFromTreasuries = data
          this.FilterFromTreasuries.unshift(this.emptyRec)
          this.isLoadingData = false
        })
    },
    // ================================================
    getTreasuryTo () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranchTreasuries', {
        token: localStorage.getItem('token'),
        branche_id: this.FilterToBranchID
      })
        .then(({ data }) => {
          this.FilterToTreasuries = data
          this.FilterToTreasuries.unshift(this.emptyRec)
          this.isLoadingData = false
        })
    },
    // ================================================
    GetData () {
      this.mainValidationErrors = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getTreasuryMovment', {
        token: localStorage.getItem('token'),
        treasury_from_id: this.FilterFromTreasuryID,
        treasury_to_id: this.FilterToTreasuryID,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'treasury_from_id': '', 'treasury_to_id': '', 'amount': '', 'date': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveTreasuryMovment', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        treasury_from_id: this.record.treasury_from_id,
        treasury_to_id: this.record.treasury_to_id,
        amount: this.record.amount,
        date: this.record.date
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteTreasuryMovment', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/TreasuryMovments.vue